import * as yup from 'yup';

function countryCode(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CREATEFORM_COUNTRYCODE_FIELD_IS_REQUIRED',
      defaultMessage: 'Country Code is required',
    }),
  );
}

function countryCodeAlpha3(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CREATEFORM_COUNTRYCODEALPHA3_FIELD_IS_REQUIRED',
      defaultMessage: 'Country Code Alpha3 is required',
    }),
  );
}

function countryName(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CREATEFORM_COUNTRYNAME_FIELD_IS_REQUIRED',
      defaultMessage: 'Country Name is required',
    }),
  );
}

function currencyCode(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CREATEFORM_CURRENCYCODE_FIELD_IS_REQUIRED',
      defaultMessage: 'Currency Code is required',
    }),
  );
}

function isActive(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CREATEFORM_ISACTIVE_FIELD_IS_REQUIRED',
      defaultMessage: 'Status is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      countryCode: countryCode(formatMessage),
      countryCodeAlpha3: countryCodeAlpha3(formatMessage),
      countryName: countryName(formatMessage),
      currencyCode: currencyCode(formatMessage),
      isActive: isActive(formatMessage),
    })
    .required();

export default validationSchema;
